export default __webpack_public_path__ + "static/media/img-card-01.139529d1.jpg";